import { cn } from '@commenda/utils';
import moment from 'moment';
import React from 'react';
import { CALENDAR_TODAY_ACCENT } from './calendar.constants';

interface CalendarDateHeaderProps {
  date: Date;
  isOffRange?: boolean;
  label: string;
  onDrillDown?: (e: React.SyntheticEvent) => void;
}

const CalendarDateHeader = ({
  date,
  isOffRange,
  onDrillDown,
}: CalendarDateHeaderProps) => {
  const isToday = moment(date).isSame(moment(), 'day');
  const isMonthStart = date.getDate() === 1;
  const dayNumber = date.getDate();
  const monthName = moment(date).format('MMMM');
  const textClass = isOffRange ? 'text-fg-quaternary' : 'text-fg-primary';

  if (isMonthStart && !isToday) {
    return (
      <div
        className="flex items-center p-1 cursor-pointer"
        onClick={onDrillDown}
      >
        <div className="flex items-center gap-1 p-1 rounded-[2px]">
          <span className={cn('txt-small-bold whitespace-nowrap', textClass)}>
            {monthName}
          </span>
          <span className={cn('txt-small-regular', textClass)}>{dayNumber}</span>
        </div>
      </div>
    );
  }

  if (isToday) {
    return (
      <div
        className="flex items-center justify-end p-1 cursor-pointer"
        onClick={onDrillDown}
      >
        <div
          className="flex flex-col items-center justify-center p-1 rounded-xs"
          style={{ backgroundColor: CALENDAR_TODAY_ACCENT }}
        >
          <span className="txt-small-regular text-white">{dayNumber}</span>
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex items-center justify-end p-1 cursor-pointer"
      onClick={onDrillDown}
    >
      <div className="flex flex-col items-center justify-center p-1 rounded-[2px]">
        <span className={cn('txt-small-regular', textClass)}>{dayNumber}</span>
      </div>
    </div>
  );
};

export default CalendarDateHeader;
